export enum PDMPVendorEnums  {
    Bamboo = 1,
    Logicoy = 2,
    BambooVendor = "Bamboo",
    LogicoyVendor = "Logicoy"
}

export enum FeatureFlagEnum {
    MultiNPIConfiguration = 1
}